import { createCmsClient } from "@kozien/shared";

export const cmsClient = createCmsClient(
    import.meta.env.VITE_CMS_GRAPHQL_ENDPOINT,
);
